export default __webpack_public_path__ + "static/media/MiniIcons5.2fee8651.png";